import React from "react"

export interface ISprintFeedback {
    questionNumber: number
    correctAnswer: string
    userSubmittedAnswer?: string
}

export default function FeedbackView({feedback}: {feedback: ISprintFeedback}) {
    let {questionNumber, correctAnswer, userSubmittedAnswer} = feedback
    let answered = !!userSubmittedAnswer && userSubmittedAnswer !== "?"
    let correct = answered && userSubmittedAnswer === correctAnswer

    return (
        <div className="sprint-feedback">
            <span><b>Timed Sprint Q{questionNumber}:</b> Correct answer is {correctAnswer}.</span>{" "}
            <span>
                {correct ? "You answered correctly." : answered
                    ? `Your answer is ${userSubmittedAnswer}.`
                    : "You left it blank."}
            </span>
        </div>
    )
}
